// src/lib/JobsiteMiniMap.js
// A wide map strip with one centered dot on a street address — shared by the
// project Overview card and the customer Billing/Project Address card. Styled
// like the Employee Scheduling map (dark keyless OSM tiles). Basic zoom
// (buttons + scroll wheel + pinch) and drag-to-pan are enabled.
// Renders nothing when there's no address or geocoding fails.
import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { loadGoogleMaps } from './googlePlaces';

export default function JobsiteMiniMap({ address, className = '' }) {
  const [pin, setPin] = useState(null); // { lat, lng } | null
  useEffect(() => {
    let alive = true;
    setPin(null);
    if (!address) return;
    (async () => {
      try {
        await loadGoogleMaps();
        if (!window.google?.maps?.Geocoder) return;
        new window.google.maps.Geocoder().geocode({ address }, (res, status) => {
          if (!alive) return;
          if (status === 'OK' && res?.[0]?.geometry?.location) {
            setPin({ lat: res[0].geometry.location.lat(), lng: res[0].geometry.location.lng() });
          }
        });
      } catch (_) { /* no geocoder — just no map */ }
    })();
    return () => { alive = false; };
  }, [address]);

  if (!pin) return null;
  return (
    <div className={`relative z-0 rounded-xl overflow-hidden border border-gray-800/70 h-40 w-full ${className}`}>
      <style>{`.map-tiles-dark { filter: var(--map-tiles-filter, invert(100%) hue-rotate(180deg) brightness(95%) contrast(90%) grayscale(35%)); }`}</style>
      <MapContainer
        key={`${pin.lat},${pin.lng}`}
        center={[pin.lat, pin.lng]}
        zoom={15}
        style={{ height: '100%', width: '100%', background: '#111827' }}
        zoomControl={false}
        scrollWheelZoom={true}
        attributionControl={false}
      >
        <TileLayer
          className="map-tiles-dark"
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; OpenStreetMap contributors'
        />
        <Marker
          position={[pin.lat, pin.lng]}
          icon={L.divIcon({
            className: 'custom-marker',
            html: `<div style="background-color:#6366f1;width:16px;height:16px;border-radius:50%;border:2px solid #e5e7eb;box-shadow:0 0 6px rgba(0,0,0,0.6);"></div>`,
            iconSize: [16, 16],
            iconAnchor: [8, 8],
          })}
        />
      </MapContainer>
    </div>
  );
}
